import { render, staticRenderFns } from "./authorize_login.vue?vue&type=template&id=0a56568a&"
import script from "./authorize_login.vue?vue&type=script&lang=js&"
export * from "./authorize_login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports